// extracted by mini-css-extract-plugin
module.exports = {"socialShare":"style_socialShare__kjYUY","shareButton":"style_shareButton__z0cu8","icon":"style_icon__15V4w","tooltip":"style_tooltip__cFOJr g-type-body-small"};